import type { TestKeyboardInputElementValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './TestKeyboardInputElement'
import type { TestKeyboardInputDemoType } from './testKeyboardInputTypes'

const DEMO_VALUE: TestKeyboardInputElementValue = {
  items: [],
}

const TestKeyboardInputDemo: TestKeyboardInputDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.testKeyboardInput.type}-demo`,
        type: CONFIG_ELEMENTS.testKeyboardInput.type,
        value: DEMO_VALUE,
        font: {},
        style: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={styles}
    />
  </DemoWrapper>
)

export default TestKeyboardInputDemo
